import React, { useState, useEffect } from "react";
import "../styles/solutionStyles.css";
import productsData from "../data/products.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles
import seoFriendlySlug from "../utils/seoFriendlySlug";

const Solutions = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };

  const categories = productsData.products;

  const [sliderSettings, setSliderSettings] = useState({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
  });

  useEffect(() => {
    // Initialize AOS with `once: true`
    AOS.init({
      once: true, // This will ensure the animation triggers only once
    });

    const updateSliderSettings = () => {
      if (window.innerWidth <= 768) {
        setSliderSettings({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: true,
          autoplaySpeed: 3000,
          pauseOnHover: true,
          arrows: true,
        });
      } else {
        setSliderSettings({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "0",
          autoplay: true,
          autoplaySpeed: 3000,
          pauseOnHover: true,
          arrows: true,
        });
      }
    };

    // Update settings on mount and on window resize
    updateSliderSettings();
    window.addEventListener("resize", updateSliderSettings);

    return () => window.removeEventListener("resize", updateSliderSettings);
  }, []);

  return (
    <div
      className="solution-container"
      data-aos="fade-up"
      data-aos-easing="ease-in-out"
    >
      <div className="solution-content">
        <div className="solution-heading">
          <h2 className="sol-heading" style={{ fontWeight: "bold" }}>
            Our Solutions
          </h2>
        </div>
        <div className="pricing">
          <Slider {...sliderSettings}>
            {categories.slice(0, 7).map((category, index) => {
              return (
                <div key={index} className="card">
                  <Link
                    to={`${basePath}market-place/${seoFriendlySlug(category.categoryName)}`}
                    onClick={() => {
                      scrollToTop();
                    }}
                  >
                    <img
                      src={require(`../assets${category.heroimage}`)} // Use URL directly from JSON
                      alt={category.categoryName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ensure image covers the area
                      }}
                    />
                    <h3
                      className="cat-name-card text-decoration-none"
                      style={{ textDecoration: "none" }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.textDecoration = "none")
                      }
                    >
                      {category.categoryName}
                    </h3>
                  </Link>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
